"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getAccountShape = exports.getTxToBroadcast = exports.getAddress = exports.mapTxToOps = exports.processTxs = exports.getUnit = void 0;
var currencies_1 = require("../../../../currencies");
var bignumber_js_1 = require("bignumber.js");
var api_1 = require("./api");
var account_1 = require("../../../../account");
var operation_1 = require("../../../../operation");
var flatMap_1 = __importDefault(require("lodash/flatMap"));
var getUnit = function () { return (0, currencies_1.getCryptoCurrencyById)("filecoin").units[0]; };
exports.getUnit = getUnit;
var processTxs = function (txs) {
    var txsById = txs.reduce(function (result, currentTx) {
        var hash = currentTx.hash, type = currentTx.type;
        var txById = result[hash] || {};
        if (type == "Send" || type == "Fee")
            txById[type] = currentTx;
        result[hash] = txById;
        return result;
    }, {});
    var processedTxs = [];
    for (var txId in txsById) {
        var _a = txsById[txId], feeTx = _a.Fee, sendTx = _a.Send;
        if (feeTx)
            sendTx.fee = feeTx.amount;
        processedTxs.push(sendTx);
    }
    return processedTxs;
};
exports.processTxs = processTxs;
var mapTxToOps = function (accountId, _a) {
    var address = _a.address;
    return function (tx) {
        var to = tx.to, from = tx.from, hash = tx.hash, timestamp = tx.timestamp, amount = tx.amount, fee = tx.fee;
        var ops = [];
        var date = new Date(timestamp * 1000);
        var value = (0, currencies_1.parseCurrencyUnit)((0, exports.getUnit)(), amount.toString());
        var feeToUse = (0, currencies_1.parseCurrencyUnit)((0, exports.getUnit)(), (fee || 0).toString());
        var isSending = address === from;
        var isReceiving = address === to;
        if (isSending) {
            ops.push({
                id: (0, operation_1.encodeOperationId)(accountId, hash, "OUT"),
                hash: hash,
                type: "OUT",
                value: value.plus(feeToUse),
                fee: feeToUse,
                blockHeight: tx.height,
                blockHash: null,
                accountId: accountId,
                senders: [from],
                recipients: [to],
                date: date,
                extra: {}
            });
        }
        if (isReceiving) {
            ops.push({
                id: (0, operation_1.encodeOperationId)(accountId, hash, "IN"),
                hash: hash,
                type: "IN",
                value: value,
                fee: feeToUse,
                blockHeight: tx.height,
                blockHash: null,
                accountId: accountId,
                senders: [from],
                recipients: [to],
                date: date,
                extra: {}
            });
        }
        return ops;
    };
};
exports.mapTxToOps = mapTxToOps;
var getAddress = function (a) {
    return a.freshAddresses.length > 0
        ? a.freshAddresses[0]
        : { address: a.freshAddress, derivationPath: a.freshAddressPath };
};
exports.getAddress = getAddress;
var getTxToBroadcast = function (operation, signature) {
    var extra = operation.extra, senders = operation.senders, recipients = operation.recipients, value = operation.value, fee = operation.fee;
    var gasLimit = extra.gasLimit, gasFeeCap = extra.gasFeeCap, gasPremium = extra.gasPremium, method = extra.method, version = extra.version, nonce = extra.nonce, signatureType = extra.signatureType;
    return {
        message: {
            version: version,
            method: method,
            nonce: nonce,
            params: "",
            to: recipients[0],
            from: senders[0],
            gaslimit: gasLimit.toNumber(),
            gaspremium: gasPremium.toString(),
            gasfeecap: gasFeeCap.toString(),
            value: value.minus(fee).toFixed()
        },
        signature: {
            type: signatureType,
            data: signature
        }
    };
};
exports.getTxToBroadcast = getTxToBroadcast;
var getAccountShape = function (info) { return __awaiter(void 0, void 0, void 0, function () {
    var address, currency, derivationMode, accountId, blockHeight, balance, rawTxs, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                address = info.address, currency = info.currency, derivationMode = info.derivationMode;
                accountId = (0, account_1.encodeAccountId)({
                    type: "js",
                    version: "2",
                    currencyId: currency.id,
                    xpubOrAddress: address,
                    derivationMode: derivationMode
                });
                return [4 /*yield*/, (0, api_1.fetchBlockHeight)()];
            case 1:
                blockHeight = _a.sent();
                return [4 /*yield*/, (0, api_1.fetchBalances)(address)];
            case 2:
                balance = _a.sent();
                return [4 /*yield*/, (0, api_1.fetchTxs)(address)];
            case 3:
                rawTxs = _a.sent();
                result = {
                    id: accountId,
                    balance: new bignumber_js_1.BigNumber(balance.total_balance),
                    spendableBalance: new bignumber_js_1.BigNumber(balance.spendable_balance),
                    operations: (0, flatMap_1["default"])((0, exports.processTxs)(rawTxs), (0, exports.mapTxToOps)(accountId, info)),
                    blockHeight: blockHeight.current_block_identifier.index
                };
                return [2 /*return*/, result];
        }
    });
}); };
exports.getAccountShape = getAccountShape;
//# sourceMappingURL=utils.js.map